import { salesReprocessAxios, thirdPartyAxios } from '../config/axiosInstances';

export interface FindReprocessRequest {
  countryAcronym: string;
  storeAcronym?: string;
  businessDate?: string;
  reprocessType?: string;
  status?: string;
  federativeEntity?: string;
}

export type FindReprocessResponse = {
  country_store_business_date: string;
  reprocess_type: string;
  business_date: string;
  country: string;
  creation_date: string;
  execution_date: string;
  justification: string;
  status: string;
  store: string;
  user: string;
  federative_entity?: string;
}[];

export interface FindReprocessParametersResponse {
  statuses: string[];
}

export interface CreateReprocessRequest {
  countryAcronym: string;
  stores: string[];
  businessDateFrom: string;
  businessDateTo: string;
  justification: string;
}

export interface CreateReprocessSalesPARequest {
  countryAcronym: string;
  businessDateFrom: string;
  businessDateTo: string;
  justification: string;
}

export interface CreateReprocessFtpRequest {
  accountingDate: string;
}

export interface CreateReprocessEmiteMXRequest {
  countryAcronym: string;
  stores: string;
  businessDateFrom: string;
  businessDateTo: string;
  justification: string;
}

export default class {
  static async findReprocessParameters() {
    return salesReprocessAxios.get<FindReprocessParametersResponse>(`/reprocess/parameters`);
  }

  static async findReprocess(request: FindReprocessRequest) {
    return salesReprocessAxios.get<FindReprocessResponse>(`/reprocess`, {
      params: request,
    });
  }

  static async createReprocess(data: CreateReprocessRequest) {
    return thirdPartyAxios.post(`/sales-requester`, data);
  }

  static async createReprocessSalesPA(data: CreateReprocessSalesPARequest) {
    return thirdPartyAxios.post(`/reprocess-sales`, data);
  }

  static async createReprocessFtp(data: CreateReprocessFtpRequest) {
    return thirdPartyAxios.post(`/ftp-requester`, data);
  }

  static async createReprocessEmiteMX(data: CreateReprocessEmiteMXRequest) {
    return thirdPartyAxios.post(`/emite-mx-requester`, data);
  }

  static async createReprocessSeedbilingEC(data: CreateReprocessSalesPARequest) {
    return thirdPartyAxios.post(`/seedbilling-ec-requester`, data);
  }
}
